// PLACEHOLDER that does not implement localization ; props to localizeWithRef: children, closeLabel
import { PopoverHeader } from '@amzn/meridian/popover';
import { Logger } from '../../../utils/logger';

Logger.warn('We are still working on localizing PopoverHeader. This placeholder file re-exports Meridian component.');
export default PopoverHeader;
